import React, { createContext, useReducer } from "react";

import {notificationContextReducer} from "./Reducers/NotificationContext.reducer";

const defaultValues = {
    notificationJob: {
        jobId: null,
        jobType: null,
    },
    dispatchNotificationContext: () => {},
};

export const NotificationContext = createContext(defaultValues);

const NotificationContextProvider = (props) => {
    const [notificationJob, dispatchNotificationContext] = useReducer(
        notificationContextReducer,
        defaultValues.notificationJob
    );

    return (
        <NotificationContext.Provider value={{ notificationJob, dispatchNotificationContext }}>
            {props.children}
        </NotificationContext.Provider>
    );
};

export { NotificationContextProvider };
